export const LoanBalanceScenariosTable = ({
  data,
  handleInputChange,
  onBlur,
}: {
  data: Record<string, any>
  handleInputChange: (key: string, value: string | number | any[]) => void
  onBlur: Function
}) => (
  <div className="flex flex-col gap-1">
    <p className="font-semibold">Loan Balance Scenarios</p>
    <table className="w-full text-sm table-fixed font-medium">
      <tbody>
        <tr>
          <td className="m-0 p-2 border font-light">How much will be owed after 5 years?</td>
          {data?.loanExpect?.map((value: number, index: number) => (
            <td key={index} className="m-0 p-2 border font-light">
              <span className="mr-1">$</span>
              <input
                type="number"
                value={value || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.loanExpect]
                  updatedValues[index] = parseFloat(e.target.value)
                  handleInputChange('loanExpect', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </td>
          ))}
        </tr>
        <tr>
          <td className="m-0 p-2 border font-light">Has the loan balance been reduced after 5 years of payments?</td>
          <td className="m-0 p-2 border font-light">
            <p className="font-semibold text-center">Yes</p>
            <p>
              <span className="mr-1">The loan balance was reduced by $</span>
              <input
                type="number"
                value={data?.balanceExpect?.[0] || 0}
                className="p-0 text-center w-16"
                onChange={(e) => {
                  const updatedValues = [...data.balanceExpect]
                  updatedValues[0] = parseFloat(e.target.value)
                  handleInputChange('balanceExpect', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </p>
          </td>
          <td className="m-0 p-2 border font-light">
            <p className="font-semibold text-center">No</p>
            <p>The loan balance was not reduced</p>
          </td>
          <td className="m-0 p-2 border font-light">
            <p className="font-semibold text-center">Yes</p>
            <span className="mr-1">The loan balance was reduced by $</span>
            <input
              type="number"
              value={data?.balanceExpect?.[1] || 0}
              className="p-0 text-center w-16"
              onChange={(e) => {
                const updatedValues = [...data.balanceExpect]
                updatedValues[1] = parseFloat(e.target.value)
                handleInputChange('balanceExpect', updatedValues)
              }}
              onBlur={() => onBlur()}
            />
          </td>
          <td className="m-0 p-2 border font-light">
            <p className="font-semibold text-center">No</p>
            <p>The loan balance was not reduced</p>
          </td>
          <td className="m-0 p-2 border font-light max-w-xs">
            <p className="font-semibold text-center mb-1">No</p>
            <p className="flex flex-wrap items-center justify-start text-sm gap-x-1">
              <span>The loan balance</span>
              <span className="font-semibold">increased</span>
              <span>by $</span>
              <input
                type="number"
                value={data?.balanceExpect?.[2] || 0}
                className="p-0 text-center w-16 border rounded"
                onChange={(e) => {
                  const updatedValues = [...data.balanceExpect]
                  updatedValues[2] = parseFloat(e.target.value)
                  handleInputChange('balanceExpect', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </p>
          </td>
          <td className="m-0 p-2 border font-light align-top">
            <p className="font-semibold text-center">No/Yes</p>
            <p className="text-sm leading-snug break-words text-gray-800 text-left">
              <span>The loan balance:</span>
              <span className="font-semibold inline-block max-w-full break-words ml-1">
                did not change / increased / decreased
              </span>
              <span className="mr-1">by $</span>
              <input
                type="number"
                value={data?.balanceExpect?.[3] || 0}
                className="p-0 text-center w-16 border rounded"
                onChange={(e) => {
                  const updatedValues = [...data.balanceExpect]
                  updatedValues[3] = parseFloat(e.target.value)
                  handleInputChange('balanceExpect', updatedValues)
                }}
                onBlur={() => onBlur()}
              />
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default LoanBalanceScenariosTable
